import './VideoScreen.css';

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy'

import db, { storage } from '../Core/firebaseCore';
import Loading from './Components/Loading';
import NotFound from './Components/NotFound';

function VideoScreen() {
    const [video, setVideo] = useState();
    const { videoId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(async () => {
        if (videoId) {
            const _snapshot = await db.collection('videos').doc(videoId).get();
            if (_snapshot.data()) {
                let videos_local = _snapshot.data();
                videos_local.id = videoId;
                //= get video url from storage
                storage.ref().child(`videos/${videoId}.mp4`).getDownloadURL().then((result) => {
                    videos_local.video_src = result;
                    // console.log(videos_local);
                    setVideo(videos_local);
                }).catch((error) => { console.log('e'); }).finally(() => { setIsLoading(false); });
            } else { setIsLoading(false); }
        }
    }, []);

    return (
        <div className="video">
            {isLoading ? (<Loading />) : (<>
                {!video ? (<NotFound />) :
                    (<>
                        <ReactPlayer
                            controls={true} width='100%'
                            // light={video.thumbnail_src}
                            config={{
                                file: { attributes: { controlsList: 'nodownload' } }
                            }}
                            url={video.video_src} />
                        <h5 className="center">{video.title}</h5>
                        <p className="center">- {video.host_name}</p>
                    </>)
                }
            </>)}
        </div>
    )
}

export default VideoScreen
